module.exports = __webpack_public_path__ + "img/node.7ac49cd0.png";